import { STORE_ENTITIES } from '@app/constants'
import { App_User_Public } from '@app/types'

export class Set_User_Public {
  public static readonly type = `[${STORE_ENTITIES.USER_PUBLIC}] Set User Public`
  constructor(public payload: Partial<App_User_Public>) { }
}
